import './style.scss';
import {autoplaySwiper} from "../../scripts/autoplay-swiper";

export function brands_logos_block() {
    const blocks = document.querySelectorAll('.brands_logos_block');
    if (!blocks.length) return;

    const pixelsPerSecond = typeof window.logosSpeed === 'number' ? window.logosSpeed * 1000 : 30000;


    blocks.forEach((block) => {
        autoplaySwiper(block, {
            slidesPerView: 'auto',
            spaceBetween: 32,
            speed: 30000,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                },
                992: {
                    slidesPerView: 'auto',
                    spaceBetween: 64
                }
            }
        });

        const swiperContainer = block.querySelector('.autoplay-swiper');
        if (swiperContainer) {
            // Initialize paused
            swiperContainer.style.animationPlayState = 'paused';

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        swiperContainer.style.animationPlayState = 'running';
                    } else {
                        swiperContainer.style.animationPlayState = 'paused';
                    }
                });
            }, {
                threshold: 0.1 // Trigger when 10% of the block is visible
            });

            observer.observe(block);
        }
    });
}
